import React, { useState, useEffect } from 'react';
import moment from 'moment';

import ProgressBar from 'components/ProgressBar/ProgressBar';
import { RectangleButton } from 'components/Button/RectangleButton';
import { MidContainer, ProgressRowContainer, ProgressBarAndTimeContainer, ProgressTime } from './styles';
import { useFreecodeContextLayout } from 'hooks/useContext';

export default function FreecodeProgressBar({ ticket }) {
  const { setDisplaySubmit } = useFreecodeContextLayout();

  const [timeLeft, setTimeLeft] = useState(ticket.timeLimit);
  const [timeLeftUnit, setTimeLeftUnit] = useState(undefined);
  const [percent, setPercent] = useState(0);
  const [hideProgress, setHideProgress] = useState(false);

  useEffect(() => {
    if (!ticket?.startedAt) return;
    const updateTimeLeft = () => {
      const deadline = ticket.extendedDeadline || ticket.deadlineAt;
      let newTimeLeft = moment(deadline).diff(Date.now(), 'seconds') + ticket.diffToServerTimeInSeconds;
      let newTimeLeftUnit = 'seconds';

      let secondsPassed = moment(Date.now()).diff(ticket.startedAt, 'seconds') - ticket.diffToServerTimeInSeconds;
      setPercent((100 * secondsPassed) / (secondsPassed + newTimeLeft));

      if (newTimeLeft > 60) {
        newTimeLeft = moment(deadline).add(1, 'minutes').diff(Date.now(), 'minutes');
        newTimeLeft += Math.floor(ticket.diffToServerTimeInSeconds / 60);
        newTimeLeftUnit = 'minutes';
      }

      // Update timeLeft with a function to access the old value
      const setTimeLeftHelper = (oldTimeLeft) => {
        if (newTimeLeftUnit === 'minutes' && oldTimeLeft === 5 && newTimeLeft < oldTimeLeft) setHideProgress(false);
        return newTimeLeft;
      };

      setTimeLeft(setTimeLeftHelper);
      setTimeLeftUnit(newTimeLeftUnit);

      if (newTimeLeft <= 0) {
        clearInterval(timeLeftInterval);
        setDisplaySubmit(true);
      }
    };

    updateTimeLeft();
    const timeLeftInterval = setInterval(updateTimeLeft, 1000);
    return () => {
      clearInterval(timeLeftInterval);
    };
  }, [
    setDisplaySubmit,
    ticket?.deadlineAt,
    ticket?.startedAt,
    ticket?.extendedDeadline,
    ticket?.diffToServerTimeInSeconds,
  ]);

  const toggleHide = () => setHideProgress(!hideProgress);

  return (
    <MidContainer>
      <ProgressRowContainer>
        {!hideProgress && (
          <ProgressBarAndTimeContainer>
            <ProgressBar percent={percent} barType="track" />
            <ProgressTime>
              {timeLeftUnit
                ? `${timeLeft} ${timeLeftUnit} remaining ${ticket.extendedDeadline ? ' - Deadline extended' : ''}`
                : 'Calculating..'}
            </ProgressTime>
          </ProgressBarAndTimeContainer>
        )}
        <RectangleButton small onClick={toggleHide}>
          {hideProgress ? 'Display Time' : 'Hide Time'}
        </RectangleButton>
      </ProgressRowContainer>
    </MidContainer>
  );
}
